module.exports = "/_next/static/images/3a690b66f3f6c8e950af49e3e2b3b646-hero-desktop-large-v1.jpg.webp";